<template>
  <div class="circular-progress-container">
    <svg class="circular-progress" :width="size" :height="size">
      <circle
        class="circular-progress-bg"
        :cx="center"
        :cy="center"
        :r="radius"
        :stroke-width="strokeWidth"
      />
      <circle
        class="circular-progress-bar"
        :class="progressColorClass"
        :cx="center"
        :cy="center"
        :r="radius"
        :stroke-width="strokeWidth"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="offset"
        :transform="`rotate(-90 ${center} ${center})`"
      />
    </svg>
    <div class="circular-progress-text">
      <span class="percentage">{{ percentage }}%</span>
      <span class="label">{{ label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircularProgress',
  props: {
    percentage: {
      type: Number,
      required: true,
      default: 0
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 100
    },
    strokeWidth: {
      type: Number,
      default: 8
    },
    color: {
      type: String,
      default: 'purple' // purple, green, etc.
    }
  },
  computed: {
    center() {
      return this.size / 2;
    },
    radius() {
      return (this.size - this.strokeWidth) / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    offset() {
      return this.circumference - (this.percentage / 100) * this.circumference;
    },
    progressColorClass() {
      return `progress-${this.color}`;
    }
  }
}
</script>

<style scoped>
.circular-progress-container {
  position: relative;
  display: inline-block;
}

.circular-progress {
  transform: rotate(-90deg);
}

.circular-progress-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.1);
}

.circular-progress-bar {
  fill: none;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.5s ease;
}

.progress-purple {
  stroke: #9b59b6;
}

.progress-green {
  stroke: #2ecc71;
}

.progress-blue {
  stroke: #3498db;
}

.progress-orange {
  stroke: #f39c12;
}

.circular-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.percentage {
  font-size: clamp(16px, 2.5vw, 20px);
  font-weight: bold;
  color: white;
  line-height: 1;
}

.label {
  font-size: clamp(10px, 1.5vw, 12px);
  color: rgba(255, 255, 255, 0.7);
  margin-top: 4px;
}

/* Responsive sizing */
@media (max-width: 767.98px) {
  .circular-progress-container {
    transform: scale(0.9);
  }
}

@media (max-width: 575.98px) {
  .circular-progress-container {
    transform: scale(0.8);
  }
}
</style>
